module.exports = __webpack_public_path__ + "gitlab-logo.png";